import {isNil} from '../utils/helpers';
import {httpClient} from '../utils/shared/http-client';

const commentHttpRepositoryContract = Object.seal({
  async get() {
    throw Error('Method get() not implemented');
  },
  async save() {
    throw Error('Method save() not implemented');
  }
});

const commentHttpRepository = Object.assign(commentHttpRepositoryContract, {

  async get(articleId, queryParams = {}) {
    return await httpClient.get(`${window.Site.commentsDomain}articles/${articleId}/comments`, queryParams);
  },

  async save(comment) {
    const commentsDomain = window.Site.commentsDomain;
    const url = isNil(comment.parentCommentId)
      ? `${commentsDomain}comments`
      : `${commentsDomain}comments/${comment.parentCommentId}/reply`;

    return await httpClient.post(url, null, comment, true);
  }
});

export {
  commentHttpRepository
};
